import { usePage } from '@inertiajs/react'
import Alert from '@atoms/Alert'
import Link from '@atoms/Link'
import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('nation_builder.connections.banner')

const SETTINGS_TAB_HREF = '/app/settings/nation_builder'

export function ReconnectionBanner() {
  const reconnectionRequired = usePage().props.reconnectionRequired as boolean

  if (!reconnectionRequired) return null

  return (
    <div className="tw:mb-2 tw:px-6 tw:pt-4">
      <Alert type="warning" title={t('title')} data-testid="reconnection-banner">
        <p className="tw:text-base">{t('body')}</p>
        <Link as="inertiaLink" href={SETTINGS_TAB_HREF} rank="link" color="warning">
          {t('reconnect_cta')}
        </Link>
      </Alert>
    </div>
  )
}
